export class ConfirmationDialog {
    keyConfirmDialog: string;
    title: string;
    message: string;
    messageTwo: string;
}